import { Theme } from '@mui/material/styles';
import { SystemStyleObject } from '@mui/system';

// Thin scrollbar for the profile/organization menus, tinted from the theme.
const menuScrollbar: SystemStyleObject<Theme> = {
  '&::-webkit-scrollbar': {
    width: '8px',
  },
  '&::-webkit-scrollbar-track': {
    background: 'transparent',
  },
  '&::-webkit-scrollbar-thumb': {
    backgroundColor: 'action.disabled',
    borderRadius: '4px',
  },
};

export default menuScrollbar;
